/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

/** `item.category` values that gate cart/quote actions on the shop card. */
export const PRODUCT_CATEGORY = {
  SERVICES: "Services",
} as const;

/** `item.stockAvailability` values that gate cart/quote actions on the shop card. */
export const STOCK_AVAILABILITY = {
  ENQUIRE: "Enquire",
} as const;
